export const FONT_SIZE_CLASSES: Record<string, { heading: string; subheading: string; body: string; small: string }> = {
    small: {
        heading: 'text-4xl md:text-5xl',
        subheading: 'text-lg md:text-xl',
        body: 'text-sm',
        small: 'text-xs'
    },
    medium: {
        heading: 'text-5xl md:text-7xl',
        subheading: 'text-xl md:text-2xl',
        body: 'text-base',
        small: 'text-sm'
    },
    large: {
        heading: 'text-6xl md:text-8xl',
        subheading: 'text-2xl md:text-3xl',
        body: 'text-lg',
        small: 'text-base'
    },
    xlarge: {
        heading: 'text-7xl md:text-9xl',
        subheading: 'text-3xl md:text-4xl',
        body: 'text-xl',
        small: 'text-lg'
    }
};

// Atomic font sizes for responsive composition
// Device-specific atomic font sizes
export const MOBILE_FONT_SIZES: Record<string, { heading: string; subheading: string; body: string; small: string }> = {
    small: {
        heading: 'text-3xl',
        subheading: 'text-lg',
        body: 'text-sm',
        small: 'text-xs'
    },
    medium: {
        heading: 'text-4xl',
        subheading: 'text-xl',
        body: 'text-base',
        small: 'text-sm'
    },
    large: {
        heading: 'text-5xl',
        subheading: 'text-2xl',
        body: 'text-lg',
        small: 'text-base'
    },
    xlarge: {
        heading: 'text-6xl',
        subheading: 'text-3xl',
        body: 'text-xl',
        small: 'text-lg'
    }
};

export const TABLET_FONT_SIZES: Record<string, { heading: string; subheading: string; body: string; small: string }> = {
    small: {
        heading: 'text-4xl',
        subheading: 'text-xl',
        body: 'text-sm',
        small: 'text-xs'
    },
    medium: {
        heading: 'text-5xl',
        subheading: 'text-2xl',
        body: 'text-base',
        small: 'text-sm'
    },
    large: {
        heading: 'text-6xl',
        subheading: 'text-3xl',
        body: 'text-lg',
        small: 'text-base'
    },
    xlarge: {
        heading: 'text-7xl',
        subheading: 'text-4xl',
        body: 'text-xl',
        small: 'text-lg'
    }
};

export const DESKTOP_FONT_SIZES: Record<string, { heading: string; subheading: string; body: string; small: string }> = {
    small: {
        heading: 'text-5xl',
        subheading: 'text-xl',
        body: 'text-base',
        small: 'text-sm'
    },
    medium: {
        heading: 'text-6xl',
        subheading: 'text-2xl',
        body: 'text-lg',
        small: 'text-base'
    },
    large: {
        heading: 'text-7xl',
        subheading: 'text-3xl',
        body: 'text-xl',
        small: 'text-lg'
    },
    xlarge: {
        heading: 'text-8xl', // Boosted as requested
        subheading: 'text-4xl',
        body: 'text-2xl',
        small: 'text-xl'
    }
};
